import React from "react";
import {Checkbox, FormControlLabel } from "@mui/material";
import { useStoreActions, useStoreState } from 'easy-peasy';
import api from '../services/api';

const AprovacoesCheckbox = () => {

  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);
  let tema = useStoreState((state) => state.tema.currTema);
  let user = useStoreState((state) => state.auth.user);

  const [aprovacao, setAprovacao] = React.useState(null);

  const loadAprovacao = async (mount) => {
    startLoading();
    try {
      let data = (
        (await api.http.get(`${tema.id}/aprovacoes`)).data
      );
      if (mount.isMounted)
        setAprovacao(data);
      stopLoading();
    } catch (error) {
      if(error.response && error.response.status==404) {
        stopLoading();
      } else {
        stopLoading({
          message: error.toString(),
          severity: 'error'
        });
        throw error;
      }
    }
  };

  const onSaveAprovacao = async(aprovado) => {
    startLoading();
    let result;
    try {
      result = await api.http.post(`${tema.id}/aprovacoes`, {
        aprovado: aprovado
      });
      setAprovacao(result.data);
      stopLoading();
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
      throw error;
    };
  };


  React.useEffect(()=>{
    let mount = {
      isMounted: true
    };
    if(tema)
      loadAprovacao(mount);
    return () => {
      mount.isMounted = false;
    };
  },[tema]);

  const onChange = (event) => {
    onSaveAprovacao(event.target.checked);
  };

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={Boolean(aprovacao && aprovacao.aprovado)}
          onChange={onChange}
          disabled={!['preenchedorSso','gestor','admin'].includes(user.roleId)}
          inputProps={{ 'aria-label': 'Checkbox' }}
        />
      }
      label='Preenchimento do GT Aprovado'
    />
  );
};

export default AprovacoesCheckbox;
